module.exports = __webpack_public_path__ + "static/assets/d3e08b540e0d05464683f3f34e9a133b.gif";